import { ReactElement, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './nav-item.module.scss';
import { useClickOutside } from 'libs/design-system/src/hooks/useClickOutside';

interface INavItem {
  icon?: ReactElement<'svg'>;
  label: string;
  active: boolean;
  route?: string;
  collapsed?: boolean;
  onClick?: () => void;
}
export const NavItem = ({
  icon,
  label,
  active = false,
  route,
  collapsed,
  onClick,
}: INavItem) => {
  const navItemRef = useRef<any>();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);

  const closeDropdown = () => {
    setIsOpen(false);
  };

  const handleNavItemClick = (route: string | undefined) => {
    route && navigate(route);
    onClick?.();
  };

  const NavItemInstance = (
    <div
      className={styles['nav-item']}
      data-nav-item-active={active}
      data-nav-item-open={isOpen}
      data-nav-item-collapsed={collapsed}
      tabIndex={0}
      onClick={() => handleNavItemClick(route)}
    >
      <div className={styles['nav-item__featured-icon']}>{icon}</div>

      {label && !collapsed && (
        <div className={styles['nav-item__label']}>{label}</div>
      )}
    </div>
  );

  useClickOutside(navItemRef, closeDropdown, isOpen);

  return <>{NavItemInstance}</>;
};
